import styled from "@emotion/styled";
import { arrayOf, oneOf, oneOfType, shape, string } from "prop-types";
import React, { useState } from "react";
import { Col, Row } from "react-flexbox-grid";

import theme from "../../theme";
import Heading from "../Heading";
import ImageComponent, { ImageDataType } from "../ImageComponent";
import AwardsItem from "./components/AwardsItem";

const Wrapper = styled.div`
  position: relative;
`;

const StyledRow = styled(Row)`
  flex-direction: row;
  align-items: center;
`;

const HeadingWrapper = styled.div`
  margin-bottom: ${theme.spacing("m")};
`;

const Sidebox = styled.div`
  margin: ${theme.space("m")};
`;

const AwardsWrapper = styled.div`
  position: relative;
  background-color: ${theme.color("primary.base")};
  min-height: 600px;
  height: 60vh;
`;

const OverflowClipper = styled.div`
  position: absolute;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // if hover-image needs to be clipped, this next line is necessary
  /* clip: rect(0, auto, auto, 0); */
`;

const Item = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  .active & {
    opacity: 0.5;
  }
  &:hover {
    opacity: 1;
  }
`;

const StyledImage = styled(ImageComponent)`
  max-height: 100px;
  max-width: 200px;
  img {
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%;
  }
`;

const BasicImage = styled.img`
  max-height: 100px;
  max-width: 200px;
`;

function Awards({ title, items, ...props }) {
  const [current, setCurrent] = useState(false);

  return (
    <Wrapper {...props}>
      <StyledRow bottom="md">
        <Col mdOffset={0} md={4}>
          <Sidebox>
            <HeadingWrapper>
              <Heading size={2}>{title}</Heading>
            </HeadingWrapper>
          </Sidebox>
        </Col>
        <Col mdOffset={0} md={8}>
          <AwardsWrapper className={current !== false ? "active" : null}>
            <OverflowClipper>
              {items.map(({ logo, id }, index) => (
                <Item
                  key={`awardsLogos-${id}`}
                  onMouseEnter={() => setCurrent(index)}
                  onMouseLeave={() => setCurrent(false)}
                >
                  {logo.data !== null ? (
                    <StyledImage data={logo.data} />
                  ) : (
                    <BasicImage
                      src={logo.url}
                      alt={logo.alt}
                      title={logo.title}
                    />
                  )}
                </Item>
              ))}
              {current !== false && (
                <AwardsItem image={items[current].image.url} />
              )}
            </OverflowClipper>
          </AwardsWrapper>
        </Col>
      </StyledRow>
    </Wrapper>
  );
}

Awards.propTypes = {
  title: string,
  items: arrayOf(
    shape({
      id: string,
      logo: shape({
        url: string,
        title: string,
        alt: string,
        data: oneOfType([oneOf([null]), shape(ImageDataType)]),
      }),
      image: shape({
        url: string,
        data: oneOfType([oneOf([null]), shape(ImageDataType)]),
      }),
    })
  ),
};

Awards.defaultProps = {};

export default Awards;
